export default "__VITE_ASSET__BGOvAZpQ__"